module.exports = __webpack_public_path__ + "68bf68e731aa43969a12aa231dcc63d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mustache-glasses.png
// module id = 2478
// module chunks = 0